import React, { useEffect, useState } from 'react';
import { Container, Spinner, Alert } from 'react-bootstrap';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import './DocumentationPage.css';

// NOTE: This slugify logic must stay in sync with concatenate-knowledge-base.sh in WarrantyServicesDocumentation
const slugify = (text: string) =>
  text.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').trim();

const headingWithId = (Tag: 'h1'|'h2'|'h3'|'h4'|'h5'|'h6') =>
  ({children, ...props}: any) => {
    const text = typeof children === 'string' ? children : String(children);
    return <Tag id={slugify(text)} {...props}>{children}</Tag>;
  };

const headingComponents = {
  h1: headingWithId('h1'), h2: headingWithId('h2'), h3: headingWithId('h3'),
  h4: headingWithId('h4'), h5: headingWithId('h5'), h6: headingWithId('h6'),
};

export default function DocumentationPage() {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/knowledge-base/knowledge-base.md')
      .then(res => {
        if (!res.ok) throw new Error(`Failed to load documentation: ${res.status}`);
        return res.text();
      })
      .then(text => { setContent(text); setLoading(false); })
      .catch(err => { setError(err.message); setLoading(false); });
  }, []);

  if (loading) return <Container className="mt-4 text-center"><Spinner animation="border" /></Container>;
  if (error) return <Container className="mt-4"><Alert variant="danger">{error}</Alert></Container>;

  return (
    <Container fluid className="mt-4 mb-5 px-5">
      <div className="documentation">
        <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={headingComponents}>{content}</ReactMarkdown>
      </div>
    </Container>
  );
}
